import React from 'react';
import c from './timeline.module.scss';
import { SpeechBubble } from '@monash/portal-react';
import classNames from 'classnames';

const Timeline = () => {
  return (
    <div className={c.container}>
      <div className={c.speechBubbleGrid}>
        <SpeechBubble className={c.speechBubble} arrowSize="0.9rem">
          When the update will appear in More updates
        </SpeechBubble>
        <SpeechBubble
          className={c.speechBubble}
          backgroundColor="var(--card-cta-bg-color)"
          textColor="var(--card-cta-text-color)"
          arrowSize="0.9rem"
        >
          When the Update will appear in Coming up soon
        </SpeechBubble>
        <SpeechBubble className={c.speechBubble} arrowSize="0.9rem">
          When the update will appear in More updates
        </SpeechBubble>
      </div>
      <div className={c.timeLineGrid}>
        <div className={c.timeLine} />
        <div className={classNames(c.timeLine, c.highlighted, c.hasDot)} />
        <div className={classNames(c.timeLine, c.hasDot)} />
      </div>
    </div>
  );
};
export default Timeline;
